import apiClient from '../../apiClient';

// ✅ 요청 타입 정의
export type ReqGetMainReviewProducts = {
  filter: {
    isPickUp?: boolean;
    isDeliveryFree?: boolean;
    isDiscount?: boolean;
    minPrice?: number;
    maxPrice?: number;
    location?: string;
    villageName?: string;
    province?: string;
    city?: string;
    district?: string;
  };
  lastId?: number;
};

// ✅ 응답 타입 정의
export type ResGetMainReviewProducts = {
  isSuccess: boolean;
  code: number;
  message: string;
  correlationId: string;
  result: {
    id: number;
    createdAt: string; // ISO Date String
    platformType: 'INVIL' | 'GROUND';
    villageName: string;
    categoryId: string;
    categoryName: string;
    marketProductName: string;
    approvalStatus: 'PENDING' | 'APPROVED' | 'REJECTED';
    businessName: string;
    originPrice: number;
    price: number;
    discountRate: number;
    thumbnailUrl: string;
    deliveryFee: number;
    isDeliveryFree: boolean;
    tagList: string[];
    state: 'ACTIVE' | 'INACTIVE';
    isPickUp: boolean;
    stockAvailable: number;
    reviewRate: number;
    reviewContent: string;
  }[];
};

const getMainReviewProducts = async (): Promise<ResGetMainReviewProducts> => {
  const { data } = await apiClient.get<ResGetMainReviewProducts>(
    '/app/market-products/review?platformType=GROUND'
  );
  return data;
};

export default getMainReviewProducts;
